export default __webpack_public_path__ + "static/media/logo-mobile.47aa2d40.svg";